import { Machine, assign } from 'xstate';
import { createFetchOptions, assertEventType } from "../util";
;
;
const assignForm = assign({
    form: (__, event) => event.data,
});
export const feedbackMachine = Machine({
    id: 'feedback',
    initial: 'unknown',
    states: {
        unknown: {
            always: [
                { target: 'feedback', cond: 'knownFeedback' },
                { target: 'key_needed', cond: 'unknownFeedback' },
            ],
        },
        key_needed: {
            initial: 'key_input',
            states: {
                key_input: {
                    on: {
                        FETCH: 'fetching_form',
                        PROCEED: '#feedback',
                    }
                },
                fetching_form: {
                    invoke: {
                        id: 'fetch-form',
                        src: 'fetchForm',
                        onDone: [
                            { target: '#feedback', cond: 'formFound', actions: ['assignForm'] },
                            { target: 'key_not_found' },
                        ],
                        onError: {
                            target: 'fetch_error',
                        }
                    },
                },
                key_not_found: {
                    on: {
                        PROCEED: '#feedback',
                        FETCH: 'key_input',
                    }
                },
                fetch_error: {
                    on: {
                        FETCH: 'key_input',
                        PROCEED: '#feedback',
                    }
                },
            },
        },
        feedback: {
            type: 'final',
            id: 'feedback',
        },
    }
}, {
    guards: {
        knownFeedback: isFeedbackType("known"),
        unknownFeedback: isFeedbackType("unknown"),
        formFound: isFetchedFeedbackType("known"),
    },
    actions: {
        assignForm: assignForm,
    },
    services: {
        fetchForm: fetchForm,
    }
});
function isFeedbackType(type) {
    return (ctx) => ctx.form.type === type;
}
function isFetchedFeedbackType(type) {
    return (__, evt) => {
        return evt.data.type == type;
    };
}
async function fetchForm(__, evt) {
    const nonce = my_ajax_obj.nonce;
    const url = my_ajax_obj.ajax_url;
    assertEventType(evt, 'FETCH');
    const key = evt.key;
    const options = createFetchOptions(nonce, 'nemova_feedbackform', {
        key
    });
    const res = await fetch(url, options);
    const result = await res.json();
    if (!result.success) {
        throw new Error(result.data.message);
    }
    return result.data;
}
export const createFeedbackMachine = (feedbackform) => {
    const machine = feedbackMachine.withContext({ form: feedbackform });
    return machine;
};
